
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["setMillis","init","getMillis"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "2ba1e846cdfcbc23af25.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			